/* eslint-disable fp/no-mutation */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export const TRACKING_PARAMS = {
  FBCLID: 'fbclid',
  GCLID: 'gclid',
  IM_REF: 'im_ref',
  IRCLICKID: 'irclickid',
  RDT_CID: 'rdt_cid',
  TWCLID: 'twclid',
} as const;

export type TrackingReduxState = {
  fbclid?: string;
  fbclidTimestamp?: number;
  gclid?: string;
  gclidTimestamp?: number;
  imRef?: string;
  imRefTimestamp?: number;
  irClickId?: string;
  irClickIdTimestamp?: number;
  rdtClickId?: string;
  rdtClickIdTimestamp?: number;
  twClickId?: string;
  twClickIdTimestamp?: number;
};

const initialState: TrackingReduxState = {};

const trackingSlice = createSlice({
  initialState,
  name: 'tracking',
  reducers: {
    clearExpiredFbclid: (state) => {
      state.fbclid = undefined;
      state.fbclidTimestamp = undefined;
    },
    clearExpiredGclid: (state) => {
      state.gclid = undefined;
      state.gclidTimestamp = undefined;
    },
    clearExpiredImRef: (state) => {
      state.imRef = undefined;
      state.imRefTimestamp = undefined;
    },
    clearExpiredIrClickId: (state) => {
      state.irClickId = undefined;
      state.irClickIdTimestamp = undefined;
    },
    clearExpiredRdtClickId: (state) => {
      state.rdtClickId = undefined;
      state.rdtClickIdTimestamp = undefined;
    },
    clearExpiredTwClickId: (state) => {
      state.twClickId = undefined;
      state.twClickIdTimestamp = undefined;
    },
    clearTracking: (state) => {
      state.fbclid = undefined;
      state.fbclidTimestamp = undefined;
      state.gclid = undefined;
      state.gclidTimestamp = undefined;
      state.irClickId = undefined;
      state.irClickIdTimestamp = undefined;
      state.imRef = undefined;
      state.imRefTimestamp = undefined;
      state.rdtClickId = undefined;
      state.rdtClickIdTimestamp = undefined;
      state.twClickId = undefined;
      state.twClickIdTimestamp = undefined;
    },
    setFbclid: (state, { payload }: PayloadAction<string>) => {
      state.fbclid = payload;
      state.fbclidTimestamp = Date.now();
    },
    setGclid: (state, { payload }: PayloadAction<string>) => {
      state.gclid = payload;
      state.gclidTimestamp = Date.now();
    },
    setImRef: (state, { payload }: PayloadAction<string>) => {
      state.imRef = payload;
      state.imRefTimestamp = Date.now();
    },
    setIrClickId: (state, { payload }: PayloadAction<string>) => {
      state.irClickId = payload;
      state.irClickIdTimestamp = Date.now();
    },
    setRdtClickId: (state, { payload }: PayloadAction<string>) => {
      state.rdtClickId = payload;
      state.rdtClickIdTimestamp = Date.now();
    },
    setTwClickId: (state, { payload }: PayloadAction<string>) => {
      state.twClickId = payload;
      state.twClickIdTimestamp = Date.now();
    },
  },
});

export const { reducer: trackingReducer } = trackingSlice;
export const {
  clearExpiredFbclid,
  clearExpiredGclid,
  clearExpiredImRef,
  clearExpiredIrClickId,
  clearExpiredRdtClickId,
  clearExpiredTwClickId,
  clearTracking,
  setFbclid,
  setGclid,
  setImRef,
  setIrClickId,
  setRdtClickId,
  setTwClickId,
} = trackingSlice.actions;
